<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item>
              <span slot="label">
                项&nbsp;&nbsp;&nbsp;目
              </span>
              <a-select
                allowClear
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item>
              <span slot="label">
                时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间
              </span>
              <a-range-picker
                style="max-width: 200px;min-width: 100%"
                @change="onChange"
                v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="6" :md="6" :sm="24">
            <a-form-item label="供货商">
              <a-select
                allowClear
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                v-decorator="['supplierId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="supplierList"
                v-model="queryParam.supplierId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="6" :sm="24">
            <a-form-item label="采购人">
              <a-select
                allowClear
                style="max-width: 200px;min-width: 100%"
                showSearch
                placeholder="请选择"
                v-decorator="['purchaserId', {rules: [{required: true, message: '请选择'}]}]"
                :options="purchaserList"
                v-model="queryParam.purchaserId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="财务确认">
              <a-select v-model="queryParam.isAmount" placeholder="请选择" allowClear>
                <a-select-option value="0">未确认</a-select-option>
                <a-select-option value="1">已确认</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate=undefined,queryParam.isSum=true}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
        <div class="table-operator">
          <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
        </div>
      </a-form>
    </div>
    <s-table
      :isInquire="false"
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <span slot="isAdvancePay" slot-scope="text,record">
        <span v-if="String(text) === '1'">
          <!--          <a-tag color="#108ee9">已确认</a-tag>-->
          <span v-if="$auth('fixedAssetsCostVerification:isAdvancePay')">
            <a-popconfirm title="是否确认预付款" @confirm="isAdvancePay(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">已确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#108ee9">已确认</a-tag>
          </span>
        </span>
        <span v-else>
          <span v-if="$auth('fixedAssetsCostVerification:isAdvancePay')">
            <a-popconfirm title="是否确认预付款" @confirm="isAdvancePay(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">未确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#f50">未确认</a-tag>
          </span>
        </span>
      </span>
      <span slot="isAmount" slot-scope="text,record">
        <span v-if="String(text) === '1'">
          <!--          <a-tag color="#108ee9">已确认</a-tag>-->
          <span v-if="$auth('fixedAssetsCostVerification:isAmount')">
            <a-popconfirm title="是否确认修改" @confirm="isAmount(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">已确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#108ee9">已确认</a-tag>
          </span>
        </span>
        <span v-else>
          <span v-if="$auth('fixedAssetsCostVerification:isAmount')">
            <a-popconfirm title="是否确认总金额" @confirm="isAmount(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">未确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#f50">未确认</a-tag>
          </span>
        </span>
      </span>
      <span slot="action" slot-scope="text,record">
        <div>
          <span v-action="'purchase:purchaseInfo:confirm'">
            <a @click="confirm(record)">修改单价</a>
          </span>
        </div>
      </span>
      <template slot="footer" style="float: right;">
        <span style="float: right; margin-right: 5%"><b>当前页合计总金额：{{ totalAmount.toFixed(2) }} 元</b></span>
        <span style="float: right; margin-right: 5%"><b>总合计总金额：{{ sumAmount.toFixed(2) }} 元</b></span>
        <span style="float: right; margin-right: 5%"><b>当前页合计预付款：{{ totalAdvancePay.toFixed(2) }} 元</b></span>
        <span style="float: right; margin-right: 5%"><b>总合计预付款：{{ sumAdvancePay.toFixed(2) }} 元</b></span>
        <br/>
      </template>
    </s-table>
    <add-price-form ref="addPriceModal" @ok="initSon"></add-price-form>
  </a-card>
</template>
<script>
import AddPriceForm from '../../purchase/purchaseInfo/component/AddPriceForm'
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropSupplierList } from '@/api/common/SxSupplier'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { dropDownByCode } from '@/api/sys/user'
import { fetchList, download, isAmount, isAdvancePay } from '@/api/statement/fixedAssetsCost'

export default {
  name: 'FixedAssetsCost',
  mixins: [TableMixin],
  components: {
    AddPriceForm
  },
  data () {
    return {
      totalAmount: 0.00, // 当前页的金额总和
      totalAdvancePay: 0.00, // 当前页预付款
      sumAmount: 0.00, // 满足当前查询条件的所有金额总和
      sumAdvancePay: 0.00, // 满足当前查询条件的所有预付款总和
      projectList: [], // 项目
      supplierList: [], // 供货人

      purchaserList: [], // 采购人
      clearDate: undefined,
      queryParam: {
        projectId: undefined,
        supplierId: undefined,
        startTime: undefined,
        endTime: undefined,
        purchaserId: undefined,
        isAmount: undefined,
        isSum: true // 用于标识是否需要求和
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      category: 'asset',
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          this.sum(res.data)
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '规格',
          dataIndex: 'format'
        },
        {
          title: '数量',
          dataIndex: 'number'
        },
        {
          title: '单位',
          dataIndex: 'unit'
        },
        {
          title: '供应商',
          dataIndex: 'supplier'
        },
        {
          title: '采购人',
          dataIndex: 'purchaser'
        },
        {
          title: '预付款',
          dataIndex: 'advancePay',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '总金额',
          dataIndex: 'totalPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        {
          title: '确认预付款',
          dataIndex: 'isAdvancePay',
          scopedSlots: { customRender: 'isAdvancePay' }
        },
        {
          title: '确认总金额',
          dataIndex: 'isAmount',
          scopedSlots: { customRender: 'isAmount' }
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    sum (data) {
      this.totalAmount = 0.00
      this.totalAdvancePay = 0.00
      this.sumAmount = data.sumAmount
      this.sumAdvancePay = data.sumAdvancePay
      data.records.map(da => {
        if (da.totalPrice) {
          this.totalAmount += Number(da.totalPrice)
        }
        if (da.advancePay) {
          this.totalAdvancePay += Number(da.advancePay)
        }
      })
    },
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH-mm-ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH-mm-ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropSupplierList().then(res => {
        this.supplierList = res.data
      })
      dropDownByCode(this.purchaserQuery).then(res => {
        this.purchaserList = res.data
      })
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
    },
    initSon () {
      this.queryPage()
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '固定资产成本统计.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    },
    isAmount (record) {
      isAmount(record).then(res => {
        this.$message.success('操作成功')
        this.queryPage()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    isAdvancePay (record) {
      isAdvancePay(record).then(res => {
        this.$message.success('操作成功')
        this.queryPage()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    confirm (record) {
      this.$refs.addPriceModal.init(record.id, this.category, 'edit')
    }
  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
